import React, { useState } from "react";
import { connect } from "react-redux";
import ProductImage from "../../../assets/images/productimage.png";
import { LogoImageReplaceIcon } from "../../../assets/icons/iconsProvider";
import { inventoryActions } from "../../../redux/actions";
import ProductImageCard from "./ProductImageCard";
import ProductImagesModal from "./ProductImagesModal";

const ProductImg = ({ productDataObject, setProductDataObject }) => {
  const [isImagesModal, setIsImagesModal] = useState(false);

  const imageSrc = productDataObject?.imgUrl || ProductImage;
  const imgUrlExtras = productDataObject?.imgUrlExtras || [];
  const toggleImagesModal = () => setIsImagesModal((prev) => !prev);

  // main image + extras, deduped (same logic the modal uses)
  const totalImages = new Set(
    [productDataObject?.imgUrl, ...imgUrlExtras].filter(Boolean)
  ).size;

  return (
    <div className="add-inventory-product-image">
      <ProductImageCard key={imageSrc} src={imageSrc} />
      <button
        onClick={toggleImagesModal}
        type="button"
        className="replace-product-image"
      >
        <LogoImageReplaceIcon className="replace-icon" />
        {totalImages > 0 && (
          <span className="product-image-count">{totalImages}</span>
        )}
      </button>

      <ProductImagesModal
        isOpen={isImagesModal}
        mainImage={productDataObject?.imgUrl}
        imgUrlExtras={imgUrlExtras}
        toggleModal={toggleImagesModal}
        productDataObject={productDataObject}
        setProductDataObject={setProductDataObject}
      />
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  uploadProductImage: (...args) =>
    dispatch(inventoryActions.uploadProductImage(...args)),
});

export default connect(null, mapDispatchToProps)(ProductImg);
